import SocioService from '../../services/SocioService'
import { buildAdminComercialPayload, validateComercialData } from '../../utils/socioComercialAdmin'

function mergeDadoComercialResponse(state, responseData) {
    return {
        ...responseData,
        Socio: state.dadoComercial?.Socio || null,
    };
}

const state = () => ({
    socio: null,
    dadoComercial: null,
    dadosComerciais: [],
    loadingComercial: false,
    pendingRqeFile: null,
    total: 0,
    pages: 0,
    page: 1,
    showModalSocio: false,
    datalistEstados: 
    [
        { "sigla": "AC", "nome": "Acre" },
        { "sigla": "AL", "nome": "Alagoas" },
        { "sigla": "AP", "nome": "Amapá" },
        { "sigla": "AM", "nome": "Amazonas" },
        { "sigla": "BA", "nome": "Bahia" },
        { "sigla": "CE", "nome": "Ceará" },
        { "sigla": "DF", "nome": "Distrito Federal" },
        { "sigla": "ES", "nome": "Espírito Santo" },
        { "sigla": "GO", "nome": "Goiás" },
        { "sigla": "MA", "nome": "Maranhão" },
        { "sigla": "MT", "nome": "Mato Grosso" },
        { "sigla": "MS", "nome": "Mato Grosso do Sul" },
        { "sigla": "MG", "nome": "Minas Gerais" },
        { "sigla": "PA", "nome": "Pará" },
        { "sigla": "PB", "nome": "Paraíba" },
        { "sigla": "PR", "nome": "Paraná" },
        { "sigla": "PE", "nome": "Pernambuco" },
        { "sigla": "PI", "nome": "Piauí" },
        { "sigla": "RJ", "nome": "Rio de Janeiro" },
        { "sigla": "RN", "nome": "Rio Grande do Norte" },
        { "sigla": "RS", "nome": "Rio Grande do Sul" },
        { "sigla": "RO", "nome": "Rondônia" },
        { "sigla": "RR", "nome": "Roraima" },
        { "sigla": "SC", "nome": "Santa Catarina" },
        { "sigla": "SP", "nome": "São Paulo" },
        { "sigla": "SE", "nome": "Sergipe" },
        { "sigla": "TO", "nome": "Tocantins" }
    ]
})
  
const mutations = {
    SET_SOCIO: (state, payload) => {
        state.socio = payload;
    },
    SET_DADO_COMERCIAL: (state, payload) => {
        state.dadoComercial = payload;
    },
    SET_DADOS_COMERCIAIS: (state, payload) => {
        if (payload.pageNumber === 1) {
            state.dadosComerciais = payload.items;
        } else {
            const existingIds = new Set(state.dadosComerciais.map((item) => item.id));
            const newItems = payload.items.filter((item) => !existingIds.has(item.id));
            state.dadosComerciais = [...state.dadosComerciais, ...newItems];
        }
        state.page = payload.pageNumber;
        state.pages = payload.pages;
        state.total = payload.total;
    },
    UPDATE_DADO_COMERCIAL_IN_LIST: (state, payload) => {
        const index = state.dadosComerciais.findIndex((item) => item.id === payload.id);
        if (index === -1) return;

        state.dadosComerciais[index] = {
            ...state.dadosComerciais[index],
            ...payload,
            Socio: state.dadosComerciais[index].Socio,
        };
    },
    SET_LOADING_COMERCIAL: (state, payload) => {
        state.loadingComercial = payload
    },
    SET_SHOW_MODAL_SOCIO: (state, payload) => {
        state.showModalSocio = payload
        if (!payload) {
            state.pendingRqeFile = null;
        }
    },
    SET_PENDING_RQE_FILE: (state, payload) => {
        state.pendingRqeFile = payload;
    },
}

const actions = {
    async fetchDadosComerciais({ commit, state }, { keyword = '', pageNumber = 1 }) {
        if (state.loadingComercial) return;

        try {
            commit('SET_LOADING_COMERCIAL', true);
            const response = await SocioService.get(keyword, pageNumber);
            commit('SET_DADOS_COMERCIAIS', response.data);
            commit('SET_LOADING_COMERCIAL', false);
        } catch (error) {
            commit('SET_LOADING_COMERCIAL', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.message || 'Erro ao carregar dados comerciais.'
            });
        }
    },
    async updateStatusDadosComerciais({commit, state}, check_adm){
        try {
            if(state.loadingComercial || state.dadoComercial.check_adm == check_adm) return
            commit('SET_LOADING_COMERCIAL', true);
            const response = await SocioService.updateAll({
                id: state.dadoComercial.id,
                check_adm
            });
            const updatedDadoComercial = response.data.dadosComercial
                ? mergeDadoComercialResponse(state, response.data.dadosComercial)
                : { ...state.dadoComercial, check_adm };

            commit('SET_DADO_COMERCIAL', updatedDadoComercial);
            commit('UPDATE_DADO_COMERCIAL_IN_LIST', updatedDadoComercial);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('SET_LOADING_COMERCIAL', false);
        } catch (error) {
            commit('SET_LOADING_COMERCIAL', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.message || 'Erro ao atualizar status.'
            });
        }
    },
    async saveDadoComercial({commit, state}){
        const validation = validateComercialData(state.dadoComercial, {
            hasPendingRqeFile: state.pendingRqeFile instanceof File,
        });
        if (!validation.valid) {
            commit('SET_ALERT', {
                heading: 'error',
                message: validation.message,
            });
            return;
        }

        try {
            commit('SET_LOADING_COMERCIAL', true);
            const payload = buildAdminComercialPayload(state.dadoComercial);
            let response;

            if (state.pendingRqeFile instanceof File) {
                const formData = new FormData();
                formData.append('rqe', state.pendingRqeFile);
                formData.append('dadosFormularios', JSON.stringify({
                    ...payload,
                    especialista: true,
                    rqe: null,
                    Socio: payload.Socio,
                }));
                response = await SocioService.updateFormData(formData);
            } else {
                response = await SocioService.updateAll(payload);
            }

            const updatedDadoComercial = response.data.dadosComercial
                ? mergeDadoComercialResponse(state, response.data.dadosComercial)
                : state.dadoComercial;

            commit('SET_DADO_COMERCIAL', updatedDadoComercial);
            commit('UPDATE_DADO_COMERCIAL_IN_LIST', updatedDadoComercial);
            commit('SET_PENDING_RQE_FILE', null);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('SET_LOADING_COMERCIAL', false);
        } catch (error) {
            commit('SET_LOADING_COMERCIAL', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.message || 'Erro ao salvar dados comerciais.'
            });
        }
    },
}

const getters = {
    getSocio: state => state.socio,
    getDadoComercial: state => state.dadoComercial,
    getDadosComerciais: state => state.dadosComerciais,
    getLoadingComercial: state => state.loadingComercial,
    getShowModalSocio: state => state.showModalSocio,
    getDatalistEstados: state => state.datalistEstados,
    getPendingRqeFile: state => state.pendingRqeFile,
}

export default {
    state,
    getters,
    mutations,
    actions
};
